export default "https://cdn.questicon.mathletics.com/assets/images/fluency-fail-ocean-6ecb5b8576e6f9862e2bef4aff1c6685.png";